import type { useTranslations } from 'next-intl';

type FooterMessageKeyType = Parameters<ReturnType<typeof useTranslations<'footer'>>>[0];

export interface IFooterLinkItem {
  href: string;
  labelKey: FooterMessageKeyType;
  isExternal?: boolean;
}

export interface IFooterLinkGroup {
  headingKey: FooterMessageKeyType;
  items: IFooterLinkItem[];
}

export const FOOTER_LINK_GROUPS: IFooterLinkGroup[] = [
  {
    headingKey: 'headings.product',
    items: [
      { href: '/pricing', labelKey: 'links.pricing' },
      { href: '/app', labelKey: 'links.app' },
      { href: '/watch', labelKey: 'links.watch' },
      { href: '/english-iq', labelKey: 'links.englishIq' },
      { href: '/compare', labelKey: 'links.compare' },
    ],
  },
  {
    headingKey: 'headings.learn',
    items: [
      { href: '/explore', labelKey: 'links.explore' },
      { href: '/collection', labelKey: 'links.collections' },
      { href: '/challenge', labelKey: 'links.words' },
      { href: '/cefr', labelKey: 'links.cefr' },
      { href: '/for', labelKey: 'links.nativeLanguages' },
    ],
  },
  {
    headingKey: 'headings.examPrep',
    items: [
      { href: '/english-exams', labelKey: 'links.englishExams' },
      { href: '/ielts', labelKey: 'links.ielts' },
      { href: '/toefl', labelKey: 'links.toefl' },
      { href: '/pte', labelKey: 'links.pte' },
      { href: '/cambridge', labelKey: 'links.cambridge' },
      { href: '/duolingo-english-test', labelKey: 'links.duolingoEnglishTest' },
    ],
  },
  {
    headingKey: 'headings.company',
    items: [
      { href: '/story', labelKey: 'links.story' },
      { href: '/about', labelKey: 'links.about' },
      { href: '/mission', labelKey: 'links.mission' },
      { href: '/vision', labelKey: 'links.vision' },
      { href: '/values', labelKey: 'links.values' },
      { href: '/social-responsibility', labelKey: 'links.socialResponsibility' },
    ],
  },
  {
    headingKey: 'headings.resources',
    items: [
      { href: '/changelog', labelKey: 'links.changelog' },
      { href: '/roadmap', labelKey: 'links.roadmap' },
      { href: '/press', labelKey: 'links.press' },
      { href: '/brand', labelKey: 'links.brand' },
      { href: '/logo', labelKey: 'links.logo' },
      { href: '/search', labelKey: 'links.search' },
    ],
  },
  {
    headingKey: 'headings.support',
    items: [
      { href: '/contact', labelKey: 'links.contact' },
      { href: '/faq', labelKey: 'links.faq' },
      { href: '/help', labelKey: 'links.help' },
      { href: '/status', labelKey: 'links.status', isExternal: true },
    ],
  },
];
